export const isFirebaseStorageUrl = (url) =>
  typeof url === "string" &&
  url.includes("firebasestorage.googleapis.com");

export const resolveProjectPhoto = ({ photo }) => {
  if (!photo || isFirebaseStorageUrl(photo)) {
    return null;
  }

  return photo;
};

export const handleProfileImageError = (event, fallbackSrc) => {
  if (event.currentTarget.src !== fallbackSrc) {
    event.currentTarget.src = fallbackSrc;
  }
};
